import { FormEvent } from 'react';
import { FormPostalCode, Error } from './styles';
import { SearchButtonHoverWrap, SearchButtonTooltip } from '../StateCityNeightborn/styles';
import { SearchAgendasIcon } from '../../../assets/icons/SearchAgendasIcon';
import { isValidCep } from '../../../utils/cep';

interface PostalCodeFormProps {
  postalCode: string;
  handlePostalCodeChange: (value: string) => void;
  handlePostalCodeSearch: (e?: FormEvent) => void;
  error: string | null;
}

const CEP_SEARCH_DISABLED_HELP =
  'Informe um CEP válido com 8 dígitos (formato 00000-000). CEPs com todos os números iguais (ex.: 00000000) não são aceitos.';

const PostalCodeForm = ({
  postalCode,
  handlePostalCodeChange,
  handlePostalCodeSearch,
  error,
}: PostalCodeFormProps) => {
  const cepOk = isValidCep(postalCode);
  const isSearchDisabled = !cepOk;

  const formatPostalCode = (value: string) => {
    let v = value.replace(/\D/g, '');
    if (v.length > 5) {
      v = v.replace(/^(\d{5})(\d{1,3})/, '$1-$2');
    }
    return v;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formattedValue = formatPostalCode(e.target.value);
    handlePostalCodeChange(formattedValue);
  };

  const onSubmitForm = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!isValidCep(postalCode)) return;
    void handlePostalCodeSearch(e);
  };

  return (
    <FormPostalCode onSubmit={onSubmitForm}>
      <label htmlFor="postalCode">Digite o CEP</label>
      <fieldset>
        <input
          type="text"
          id="postalCode"
          onChange={handleChange}
          placeholder="00000-000"
          value={postalCode}
          maxLength={9}
        />
        <a
          href="https://buscacepinter.correios.com.br/app/endereco/index.php"
          className="desktop"
          target="_blank"
          rel="noreferrer"
        >
          Nao sei meu cep
        </a>
        <SearchButtonHoverWrap className="search-agendas-wrap">
          <button
            type="submit"
            className="search-button"
            disabled={isSearchDisabled}
            aria-disabled={isSearchDisabled}
          >
            <SearchAgendasIcon />
            Buscar agendas
          </button>
          {isSearchDisabled && (
            <SearchButtonTooltip id="postal-cep-search-help" role="tooltip">
              {CEP_SEARCH_DISABLED_HELP}
            </SearchButtonTooltip>
          )}
        </SearchButtonHoverWrap>
      </fieldset>
      <a
        href="https://buscacepinter.correios.com.br/app/endereco/index.php"
        className="mobile"
        target="_blank"
        rel="noreferrer"
      >
        Nao sei meu cep
      </a>
      {error && <Error>{error}</Error>}
    </FormPostalCode>
  );
};

export default PostalCodeForm;
